<ng-template #propertyTemplate let-column="column" let-association="association">
	@for (property of column.properties; track property) {
		@if (hasDescriptionValue(association, property, true)) {
			<stages-description-view
				descriptionClass="{{ property.class }} shift-font-size"
				[html]="getValue(association, property, true)!"
			/>
		}
		@if (!hasDescriptionValue(association, property, true)) {
			<div class="{{ property.class }}">
				<ng-container>{{ getValue(association, property, true) }}</ng-container>
			</div>
		}
	}
</ng-template>

@if (associations$ | async; as associations) {
	<ul class="process-list">
		@for (association of associations; track association) {
			<li class="process-list-item">
				<div class="label">
					<div class="text">
						@for (property of $any(properties); track property) {
							@if (property.isLinkable) {
								<a [routerLink]="getRoute(association)" class="{{ property.class }}">
									<ng-container
										*ngTemplateOutlet="propertyTemplate; context: { column: property, association: association }"
									></ng-container>
								</a>
							}
							@if (!property.isLinkable) {
								<div class="{{ property.class }}">
									<ng-container
										*ngTemplateOutlet="propertyTemplate; context: { column: property, association: association }"
									></ng-container>
								</div>
							}
						}
					</div>
				</div>
			</li>
		}
	</ul>
}
